// extracted by mini-css-extract-plugin
export default {"select":"UpgradeUser_select__KAK+x"};